import { useState, useEffect } from 'react';
export function useAsyncReplace(action, resolve) {
    if (resolve === void 0) { resolve = function () { }; }
    var _a = useState(false), executing = _a[0], setExecuting = _a[1];
    var error = executing instanceof Error ? executing : undefined;
    useEffect(function () {
        if (executing === true) {
            var active_1 = true;
            action().then(function (result) { return active_1 && resolve(result); }, function (err) { return active_1 && setExecuting(err); });
            return function () { return (active_1 = false); };
        }
        return function () { };
    }, [executing]);
    return [executing === true, function () { return setExecuting(true); }, error, function () { return setExecuting(false); }];
}
//# sourceMappingURL=useAsyncReplace.js.map